// extracted by mini-css-extract-plugin
module.exports = {"card":"FoodCard_card__2-u9N","card__image_wrapper":"FoodCard_card__image_wrapper__1V4hG","title":"FoodCard_title__3NSYC","cancel_button":"FoodCard_cancel_button__1CRD6"};